import CalculatedText from "./CalculatedText";
export default CalculatedText;
